import {IonLoading, IonRouterOutlet} from '@ionic/react';
import React from 'react';
import {connect} from 'react-redux';
import {Redirect, Route, RouteComponentProps} from 'react-router';
import Contest from "../../domain/Contest";
import CalendarItems from "../../domain/CalendarItems";
import SearchResult from "./SearchResult";
import ContestDetailInfoTab from "./ContestDetailInfoTab";
import ContestDetailSeriesTab from "./ContestDetailSeriesTab";
import {actions, RootState} from "../../store";
import {PayloadMetaAction} from "typesafe-actions/dist/types";
import ContestDetailMapTab from "./ContestDetailMapTab";

type ContestDetailContentComponentProps = RouteComponentProps<{ contestId: string, tab: string }> & typeof mapDispatchToProps & {
  contest?: Contest,
  lastUpdatedTimeStamp: Date,
  calendarItems: CalendarItems,
  searchValue?: string
};

type State = {
  showLoading: boolean;
}

class ContestDetailContentComponent extends React.Component<ContestDetailContentComponentProps, State> {
  private isCommingFromSearchScreen: boolean = false;

  constructor(props: ContestDetailContentComponentProps) {
    super(props);
    this.state = {
      showLoading: false
    };
    props.updateContest(props.match.params.contestId);
  }

  componentDidMount(): void {
    setTimeout(() => {
      if (this.props.contest === undefined) {
        this.setState({showLoading: true})
      }
    }, 150);
    // @ts-ignore
    this._isUnMounting = false;
  }

  componentWillUnmount(): void {
    // @ts-ignore
    this._isUnMounting = true;
  }

  componentDidUpdate(prevProps: Readonly<RouteComponentProps<{ contestId: string; tab: string }> & { updateContest: (contestId: string) => PayloadMetaAction<string, string, undefined> } & { contest?: Contest; lastUpdatedTimeStamp: Date }>, prevState: Readonly<State>, snapshot?: any): void {
    setTimeout(() => {
      if (this.props.contest !== undefined && this.state.showLoading) {
        // @ts-ignore
        if (!this._isUnmounting) {
          this.setState({showLoading: false})
        }
      }
      if (this.props.contest === undefined && !this.state.showLoading) {
        if (this.props.contest === undefined) {
          // @ts-ignore
          if (!this._isUnmounting) {
            this.setState({showLoading: true})
          }
        }
      }
    }, 150)
  }

  render() {
    const withSearchProps = {
      searchBarEnabled: true,
      searchValue: this.props.searchValue
    };
    const withoutSearchProps = {
      searchBarEnabled: false
    };

    let content;
    if (!this.props.contest) {
    } else if ((this.props.searchValue && this.props.searchValue.length > 0) || this.isCommingFromSearchScreen) {
      content = this.renderSearchResult();
    } else {
      content = this.renderContestDetail(withSearchProps);
    }


    return (
      <>
        {content}
        {this.renderLoading()}
      </>
    );
  }

  private renderLoading() {
    return (
      <IonLoading
        isOpen={this.state.showLoading}
        onDidDismiss={() => {
        }}
        message={'Loading...'}
        duration={3000}
      />
    );
  }

  private renderSearchResult() {
    return (
      <SearchResult contest={this.props.contest!} searchValue={this.props.searchValue!}/>
    );
  }

  private renderContestDetail(searchProps: any) {
    return (
      <>
        <Route exact
               path={`/contests/${this.props.match.params.contestId}`}
               render={() => <Redirect to={`/contests/${this.props.match.params.contestId}/info`}/>}
        />
        <IonRouterOutlet>
          <Route path={`/contests/${this.props.match.params.contestId}/:tab(info)`}
                 component={() => <ContestDetailInfoTab contest={this.props.contest!}
                                                        history={this.props.history} {...searchProps}/>}
                 outlet={"tab"} exact={true}/>
          <Route path={`/contests/${this.props.match.params.contestId}/:tab(map)`}
                 component={() => <ContestDetailMapTab contest={this.props.contest!}
                                                       history={this.props.history} {...searchProps}/>}
                 outlet={"tab"} exact={true}/>
          <Route path={`/contests/${this.props.match.params.contestId}/:tab(series)`}
                 component={() => <ContestDetailSeriesTab contest={this.props.contest!}
                                                          history={this.props.history} {...this.props} {...searchProps}/>}
                 outlet={"tab"} exact={true}/>
        </IonRouterOutlet>
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => {
  return {
    calendarItems: state.calendar.thisWeeksCalendarItems,
    contest: state.contest.contest,
    lastUpdatedTimeStamp: state.contest.lastUpdatedTimeStamp,
  }
};

const mapDispatchToProps = {
  updateContest: (contestId: string) => actions.contest.updateContest(contestId)
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContestDetailContentComponent);
